import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ComponentsModule } from '@app/components/components.module';
import { ScheduleComponentsModule } from '@app/mot/schedule/components/schedule-components.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SeasonCalendarDayComponent } from './season-calendar-day/season-calendar-day.component';
import { SeasonCalendarMonthComponent } from './season-calendar-month/season-calendar-month.component';
import { SeasonCalendarWeekComponent } from './season-calendar-week/season-calendar-week.component';

const components = [SeasonCalendarDayComponent, SeasonCalendarWeekComponent, SeasonCalendarMonthComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    DirectivesModule,
    ComponentsModule,
    ScheduleComponentsModule
  ],
  declarations: components,
  exports: components
})
export class SeasonCalendarComponentsModule {}
